<template>
    <page :showBackButton="true">
        <contract-card :contractId="contractId"></contract-card>
        <h2>Ein-/Auszahlungen</h2>
        <ion-item class="ion-margin-bottom">
            <ion-label>Jahr</ion-label>
            <ion-select
                placeholder="Bitte wählen"
                cancel-text="Abbrechen"
                @ionChange="currentYear = $event.detail.value"
            >
                <ion-select-option
                    v-for="(year, index) in years"
                    :key="index"
                    :selected="index === 0"
                    >{{ year }}</ion-select-option
                >
            </ion-select>
        </ion-item>
        <ion-list>
            <template
                v-if="Object.keys(contractTransactionsGrouped).length > 0"
            >
                <ion-item-group
                    v-for="(group, groupIndex) in contractTransactionsGrouped"
                    :key="groupIndex"
                >
                    <ion-item-divider mode="ios">
                        <ion-label>{{
                            formatDate(group.BookingDate.substring(0, 10))
                        }}</ion-label>
                    </ion-item-divider>
                    <ion-item
                        v-for="(transaction,
                        transactionKey) in group.transactions"
                        :key="transactionKey"
                        @click="openTransactionDetails(transaction)"
                        button
                        mode="ios"
                    >
                        <ion-label>{{ transaction.BookingText }}</ion-label>
                        <span
                            slot="end"
                            :class="{
                                'u-color-red': transaction.Amount.startsWith(
                                    '-'
                                ),
                            }"
                            >{{ transaction.Amount | currency }}</span
                        >
                    </ion-item>
                </ion-item-group>
            </template>
            <template v-else-if="$store.state.loadingCount === 0">
                Keine Ein-/Auszahlungen vorhanden
            </template>
            <ion-item
                mode="ios"
                v-if="
                    contractTransactions.General &&
                    contractTransactions.General.Saldo &&
                    contractTransactions.General.Saldo !== '' &&
                    contractTransactions.General.SaldoDate &&
                    contractTransactions.General.SaldoDate !== ''
                "
            >
                <ion-label
                    ><b
                        >Saldo per
                        {{
                            formatDate(
                                contractTransactions.General.SaldoDate.substring(
                                    0,
                                    10
                                )
                            )
                        }}</b
                    ></ion-label
                >
                <span slot="end" style="margin-right: 28px;">
                    <b>{{ contractTransactions.General.Saldo | currency }}</b>
                </span>
            </ion-item>
        </ion-list>
    </page>
</template>

<script>
import Page from "@/components/Page";
import ContractCard from "@/components/ContractCard";
import { DateFormatter } from "@/utils/date";
import ContractTransactionModal from "@/components/ContractTransactionModal";

const toYear = new Date().getFullYear();

export default {
    components: { Page, ContractCard },
    props: ["contractId", "motive"],
    data() {
        return {
            currentYear: toYear,
        };
    },
    watch: {
        currentYear() {
            this.getContractTransactions();
        },
    },
    computed: {
        contractTransactions() {
            let result = {};
            if (
                this.$store.state.contractsTransactions.all[this.contractId] &&
                this.$store.state.contractsTransactions.all[this.contractId][
                    this.currentYear
                ]
            ) {
                result = this.$store.state.contractsTransactions.all[
                    this.contractId
                ][this.currentYear];
            }
            return result;
        },
        contractTransactionsGrouped() {
            let result = {};
            if (
                this.$store.getters["contractsTransactions/groups"][
                    this.contractId
                ] &&
                this.$store.getters["contractsTransactions/groups"][
                    this.contractId
                ][this.currentYear]
            ) {
                result = this.$store.getters["contractsTransactions/groups"][
                    this.contractId
                ][this.currentYear];
            }
            return result;
        },
        years() {
            let result = [];
            let fromYear = toYear - 4;
            if (
                this.$store.state.contracts[this.contractId] &&
                this.$store.state.contracts[this.contractId].FromDate
            ) {
                fromYear = this.$store.state.contracts[
                    this.contractId
                ].FromDate.substring(0, 4);
            }
            for (let i = toYear; i >= fromYear; i--) {
                result.push(i);
            }
            return result;
        },
    },
    mounted() {
        this.getContractTransactions();
    },
    methods: {
        getContractTransactions() {
            this.$store.dispatch(
                "contractsTransactions/getContractTransactions",
                {
                    contractId: this.contractId,
                    year: this.currentYear,
                }
            );
        },
        formatDate(dateString) {
            return DateFormatter.formatDate(new Date(dateString), "DD.MM.YYYY");
        },
        openTransactionDetails(transaction) {
            this.$ionic.modalController
                .create({
                    component: ContractTransactionModal,
                    cssClass: "c-info-modal",
                    componentProps: {
                        propsData: {
                            transaction: transaction,
                        },
                        parent: this,
                    },
                })
                .then((m) => m.present());
        },
    },
};
</script>

<style lang="scss" scoped></style>
